import {usernameConstraints, passwordConstraints } from './fieldConstraints'
import validate from './validators'

const loginFormConstraints = Object.assign({}, usernameConstraints, passwordConstraints)

export function validateLoginForm(state, action){
	const result = validate(action.data, loginFormConstraints)
	if(result){
		const validationResult = {
			usernameErrorMessage: extractErrorMessage(result.username),
			passwordErrorMessage: extractErrorMessage(result.password)
		}
		return Object.assign({}, state, validationResult)
	}else{
		return Object.assign({}, state, {
			usernameErrorMessage: undefined,
			passwordErrorMessage: undefined
		})
	}
}

function extractErrorMessage(validationResult){
	if(validationResult && validationResult.length > 0)
		return validationResult[0]
	return undefined
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/lib/form/formValidation.js